var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-page"},[(_vm.event && !_vm.isLoading)?[_c('event-participant')]:(_vm.isLoading)?_c('div',{staticClass:"event-page__loading"},[_vm._v("\n    "+_vm._s(_vm.$t("event.loading"))+"\n  ")]):(_vm.is403Error)?_c('div',{staticClass:"event-page__loading"},[_vm._v("\n    "+_vm._s(_vm.$t("event.error403"))+"\n  ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }